export enum MultimediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}
